import gql from 'graphql-tag';
import { type GetAgreementRatesFromAgreementQuery } from 'src/app/shared/graphql/agreements/get-agreement-rates-from-agreement-query.graphql.autogenerated';

export type GetAgreementRatesFromAgreementQueryResult =
  GetAgreementRatesFromAgreementQuery['agreement']['agreementRates'];

export type BudgetSupportTypesFromAgreementRatesResult =
  GetAgreementRatesFromAgreementQueryResult[number]['budgetSupportTypes'];

export const GetAgreementRatesFromAgreementDocument = gql`
  query getAgreementRatesFromAgreement($id: ID!) {
    agreement(id: $id) {
      agreementRates {
        id
        rateCents
        clientNetDollars
        workerNetDollars
        rateName
        flatRate
        grossDollars
        rateDescription
        rateSchedule {
          weekday
          saturday
          sunday
          publicHoliday
          daytime
          evening
          overnight
        }
        budgetSupportTypes {
          id
          name
          displayName
          isAdminOnlyType
        }
      }
    }
  }
`;
